'use strict';

/*global app*/
/*global initialize*/
/*global guid*/
/*global services*/
/*global blockElement*/
/*global isEmpty*/
/*global parseFloatK2*/
/*global roundToDecimals*/
/*global formatFloatK2*/
/*global formatNumberK2*/
/*global getItemById*/
/*global updateButtonByPreparationStatus*/
/*global FunctionsExecutor*/
/*global btLocation*/
/*global btHandlingUnit*/
/*global resClose*/
/*global resError*/
/*global weightNetto*/
/*global weightBrutto*/

function ProductionProcess(containerId, workplaceRID) {
  this.containerId = containerId;
  this.$container = null;
  this.workplaceRID = workplaceRID;

  this.$body = null;
  this.$form = null;
  this.$inputOperationBarcode = null;
  this.$inputOtherBarcode = null;
  this.$page = null;

  this.isLeaving = false;
  this.isFormSubmited = false;

  this.init();
}

ProductionProcess.prototype = $.extend({}, {
  constructor: 'ProductionProcess',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$form.on('click', '.production-process__btn-submit-form', function () {
      if (_this.$form.find('.blocker').length) {
        //musim kontrolovat zdali se neco nenacita - obcas zadaji umisteni bez potvrzeni a primo kliknou na submit -> musim pockat na donacteni kontroly umisteni
        setTimeout(function () {
          _this.$form.find('.production-process__btn-submit-form').trigger('click');
        }, 500);
      } else {
        _this.submitForm(true, true);
      }

      return false;
    });

    _this.$form.on('click', '.production-process__btn-leave-form', function () {
      _this.leavePage();

      return false;
    });

    _this.$form.on('submit', function () {
      return _this.isAllowedSubmitForm();
    });

    _this.$inputOperationBarcode.on('change', function () {
      _this.changeBarcode(_this.$inputOperationBarcode, $.trim($(this).val()));
    });

    _this.$inputOtherBarcode.on('change', function () {
      _this.changeBarcode(_this.$inputOtherBarcode, $.trim($(this).val()));
    });

    _this.$form.on('click', '.production-process__transfer-note-new', function () {
      _this.createNewTransferNote();
      return false;
    });

    _this.$form.on('click', '.production-process__transfer-note-bulk', function () {
      _this.createBulkTransferNote();
      return false;
    });

    _this.$form.on('change', '.production-process__operation-quantity', function () {
      _this.changeOperationQuantity('OperationQuantity');
    });

    _this.$form.on('change', '.production-process__operation-quantity-scrap', function () {
      _this.changeOperationQuantityScrap('OperationScrapQuantity');
    });

    _this.$form.on('change', '.production-process__scrap-quantity-input', function () {
      _this.changeScrapQuantity($(this).closest('.production-process__scrap'));
    });

    _this.$form.on('change', '.production-process__scrap-reason-input', function () {
      _this.changeScrapReason($(this).closest('.production-process__scrap'));
    });

    _this.$form.on('click', '.production-process__scrap-choose', function () {
      _this.chooseScrapReason($(this).closest('.production-process__scrap'));

      return false;
    });

    _this.$form.on('click', '.production-process__scrap-add', function () {
      _this.addScrap();
      return false;
    });

    _this.$form.on('click', '.production-process__scrap-remove', function () {
      _this.removeScrap($(this).closest('.production-process__scrap'));
      return false;
    });

    _this.$form.on('change', '.production-process__scrap-type', function () {
      _this.changeScrapType($(this));
      return false;
    });

    _this.$form.on('click', '.production-process__timing-start', function () {
      _this.timingStart();
      return false;
    });

    _this.$form.on('click', '.production-process__finish-process', function () {
      _this.finishProcess();
      return false;
    });

    _this.$form.on('change', '.production-process__item-value-input', function () {
      _this.changeItemQuantity($(this).closest('.production-process__item'));
    });

    _this.$form.on('stopwatch-update', '.stopwatch', function () {
      _this.timingChange($(this).data('time'));
    });

    _this.$body.on('article-change-weight', function (e, data) {
      _this.changeArticleWeight(data);
    });

    _this.$body.on('article-use-replacement', function (e, data) {
      _this.useArticleReplacement(data);
    });

    _this.$body.on('warehouse-select-batch', function (e, data) {
      _this.selectBatch(data);
    });

    _this.$body.on('job-card-preparation-toggle', function (e, data) {
      _this.toggleJobCardPreparation(data);

      return false;
    });

    _this.$body.on('job-card-preparation-item-toggle', function (e, data) {
      _this.toggleJobCardItemPreparation(data);

      return false;
    });

    services.get('key-shortcuts-manager').registerShortcut('confirm', function () {
      _this.submitForm(true, true);
    });

    services.get('key-shortcuts-manager').registerShortcut('cancel', function () {
      _this.leavePage();
    });
  },

  //----------------------------------------------------------------------------

  replaceAttrDataValue: function replaceAttrDataValue($elem, name, value) {
    $elem.attr('data-' + name, value);
    $elem.data(name, value);
  },

  getFormField: function getFormField(name) {
    var _this = this;
    return _this.$form.find('[name*="[' + name + ']"]:not([name*="]["])');
  },

  getFormValue: function getFormValue(name) {
    var _this = this;
    return $.trim(_this.getFormField(name).val());
  },

  getFormFloatValue: function getFormFloatValue(name) {
    var _this = this;

    var value = _this.getFormValue(name);
    return parseFloatK2(value);
  },

  getFormBooleanValue: function getFormBooleanValue(name) {
    var _this = this;

    var value = _this.getFormValue(name);
    return value === '1';
  },

  setFormValue: function setFormValue(name, value) {
    var _this = this;
    _this.getFormField(name).val(value);
  },

  setFormFloatValue: function setFormFloatValue(name, value) {
    var _this = this;

    value = formatFloatK2(value);
    _this.setFormValue(name, value);
  },

  getItemField: function getItemField($item, name) {
    return $item.find('[name*="][' + name + ']"]');
  },

  getItemValue: function getItemValue($item, name) {
    var _this = this;
    return $.trim(_this.getItemField($item, name).val());
  },

  getItemFloatValue: function getItemFloatValue($item, name) {
    var _this = this;

    var value = _this.getItemValue($item, name);
    return parseFloatK2(value);
  },

  getItemBooleanValue: function getItemBooleanValue($item, name) {
    var _this = this;

    var value = _this.getItemValue($item, name);
    return value === '1';
  },

  setItemValue: function setItemValue($item, name, value) {
    var _this = this;
    _this.getItemField($item, name).val(value);
  },

  setItemFloatValue: function setItemFloatValue($item, name, value) {
    var _this = this;

    value = formatFloatK2(value);
    _this.setItemValue($item, name, value);
  },

  isHolded: function isHolded() {
    var _this = this;
    return !isEmpty(_this.getFormValue('InHold'));
  },

  getJobCardRID: function getJobCardRID() {
    var _this = this;
    return _this.getFormValue('JobCardRID');
  },

  getJCOperationRID: function getJCOperationRID() {
    var _this = this;
    return _this.getFormValue('JCOperationRID');
  },

  getOperationId: function getOperationId() {
    var _this = this;
    return _this.getFormValue('OperationId');
  },

  getRemainQuantity: function getRemainQuantity() {
    var _this = this;

    return _this.getFormFloatValue('OperationRemainQuantity');
  },

  getActualQuantity: function getActualQuantity() {
    var _this = this;

    return _this.getFormFloatValue('OperationQuantity');
  },

  getInitQuantity: function getInitQuantity() {
    var _this = this;

    return _this.getFormFloatValue('OperationInitQuantity');
  },

  getLastQuantity: function getLastQuantity() {
    var _this = this;

    return _this.getFormFloatValue('OperationLastQuantity');
  },

  getScrapQuantity: function getScrapQuantity() {
    var _this = this;

    var quantity = 0;
    if (app.param('is_allowed_multi_scrap')) {
      _this.$form.find('.production-process__scrap').each(function () {
        var $scrap = $(this);

        quantity += _this.getItemFloatValue($scrap, 'Quantity');
      });
    } else {
      quantity = _this.getFormFloatValue('OperationScrapQuantity');
    }

    return quantity;
  },

  getArticleWeightNetto: function getArticleWeightNetto() {
    var _this = this;

    return _this.getFormFloatValue('ArticleWeightNetto');
  },

  getArticleWeightBrutto: function getArticleWeightBrutto() {
    var _this = this;

    return _this.getFormFloatValue('ArticleWeightBrutto');
  },

  //----------------------------------------------------------------------------

  validateCommon: function validateCommon(updateAlerts, showMessages) {
    var _this = this;

    var ret = true;
    if (isEmpty(_this.getFormValue('IsProcessable'))) {
      ret = false;
    }

    if (app.param('is_required_check_weight') && (_this.getArticleWeightNetto() <= 0 || _this.getArticleWeightBrutto() <= 0)) {
      if (showMessages) {
        app.showMessageHtml(app.t('production_process.missing_article_weight'));
      }

      ret = false;
    }

    return ret;
  },

  validateScraps: function validateScraps(updateAlerts/*, showMessages*/) {
    var _this = this;

    var ret = true;

    _this.$form.find('.production-process__scrap').each(function () {
      var $scrap = $(this);
      if (updateAlerts) {
        $scrap.removeClass('production-process__scrap--invalid');
        $scrap.find('.production-process__scrap-reason').removeClass('has-error');
        $scrap.find('.production-process__scrap-quantity').removeClass('has-error');
      }

      var reasonId = _this.getItemFloatValue($scrap, 'ReasonId');
      var quantity = _this.getItemFloatValue($scrap, 'Quantity');
      if ((reasonId !== 0 && quantity === 0) || (reasonId === 0 && quantity !== 0)) {
        ret = false;

        if (updateAlerts) {
          if (reasonId === 0) {
            $scrap.find('.production-process__scrap-reason').addClass('has-error');
          }

          if (quantity === 0) {
            $scrap.find('.production-process__scrap-quantity').addClass('has-error');
          }

          $scrap.addClass('production-process__scrap--invalid');
        }
      }
    });

    return ret;
  },

  validateItems: function validateItems(updateAlerts, showMessages) {
    var _this = this;

    var ret = true;
    var existsZeroConsumption = false;

    _this.$form.find('.production-process__item').each(function () {
      var $item = $(this);
      if (updateAlerts) {
        $item.removeClass('production-process__item--invalid');
        $item.find('.production-process__item-batch-selection').removeClass('text-danger');
      }

      var quantity = _this.getItemValue($item, 'Quantity');
      if (isEmpty(quantity)) {
        ret = false;
        existsZeroConsumption = true;

        if (updateAlerts) {
          $item.addClass('production-process__item--invalid');
        }
      }

      if (!app.param('is_allowed_process_with_zero_consumption')) {
        quantity = _this.getItemFloatValue($item, 'Quantity');
        if (quantity === 0) {
          ret = false;
          existsZeroConsumption = true;

          if (updateAlerts) {
            $item.addClass('production-process__item--invalid');
          }
        }
      }

      var isRequiredBatchSelection = _this.getItemBooleanValue($item, 'IsRequiredBatchSelection');
      var requiredBatchProperty = _this.getItemValue($item, 'RequiredBatchProperty');
      if (isRequiredBatchSelection && isEmpty(requiredBatchProperty)) {
        ret = false;

        if (updateAlerts) {
          $item.addClass('production-process__item--invalid');
          $item.find('.production-process__item-batch-selection').addClass('text-danger');
        }
      }
    });

    var msg = '';
    if (existsZeroConsumption) {
      msg += '<div class="text-center text-bold">' + app.t('production_process.exists_items_with_zero_consumption') + '</div>';
    }

    if (showMessages && msg) {
      app.showMessageHtml(msg);
    }

    return ret;
  },

  validateQuantity: function validateQuantity(updateAlerts, showMessages) {
    var _this = this;

    var ret = true;

    if (updateAlerts) {
      _this.$form.find('.production-process__operation-quantity').parent().removeClass('has-error');
    }

    //v doornite musim odvest presne mnozstvi - jinak to jsou zmetky
    var initQuantity = _this.getInitQuantity();
    var remQuantity = _this.getRemainQuantity();
    var actQuantity = _this.getActualQuantity();
    var scrapQuantity = _this.getScrapQuantity();

    actQuantity = actQuantity + scrapQuantity;
    if (!app.param('is_allowed_decrease_operation_quantity') && actQuantity < Math.min(initQuantity, remQuantity)) {
      if (updateAlerts) {
        _this.$form.find('.production-process__operation-quantity').parent().addClass('has-error');
      }

      if (showMessages) {
        app.showMessageHtml(app.t('production_process.insert_scrap_quantity'));
      }

      ret = false;
    }

    if (!app.param('is_allowed_increase_operation_quantity') && actQuantity > initQuantity) { //Math.max(initQuantity, remQuantity)
      if (updateAlerts) {
        _this.$form.find('.production-process__operation-quantity').parent().addClass('has-error');
      }

      if (showMessages) {
        app.showMessageHtml(app.t('production_process.not_allowed_process_higher_quantity'));
      }

      ret = false;
    }

    if (actQuantity <= 0) {
      if (updateAlerts) {
        _this.$form.find('.production-process__operation-quantity').parent().addClass('has-error');
      }

      if (showMessages) {
        app.showMessageHtml(app.t('production_process.not_allowed_process_zero_quantity'));
      }

      ret = false;
    }

    var isQuantityConfirmed = _this.getFormValue('IsQuantityConfirmed');
    if (_this.isRequiredConfirmQuantity() && !isQuantityConfirmed) {
      ret = false;
    }

    return ret;
  },

  removeFormAlerts: function removeFormAlerts(updateAlerts/*, showMessages*/) {
    var _this = this;

    if (updateAlerts) {
      _this.$form.find('.input-other-barcodes').parent().removeClass('has-error');
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  doRecalculateItemAltUnit: function doRecalculateItemAltUnit($item, quantity) {
    var _this = this;

    var unit = _this.getItemValue($item, 'AltUnit');
    var altUnit = app.getAltUnit(unit);
    if (!altUnit) {
      return;
    }

    var altUnitValue = roundToDecimals(quantity * altUnit.Ratio, 4);
    var valueSuffix = unit + ' <span class="production-process__item__alt-unit"> / ' + formatNumberK2(altUnitValue) + ' ' + altUnit.AltUnit + '</span>';

    var $itemValue = $item.find('.production-process__item-value');
    $itemValue.find('.value-suffix').html(valueSuffix);

    return _this;
  },

  recalculateItemAltUnit: function recalculateItemAltUnit() {
    var _this = this;

    _this.$form.find('.production-process__item').each(function () {
      var $item = $(this);

      var quantity = _this.getItemFloatValue($item, 'Quantity');

      _this.doRecalculateItemAltUnit($item, quantity);
    });

    return _this;
  },

  doRecalculateItemsQuantity: function doRecalculateItemsQuantity() {
    var _this = this;

    var quantity = _this.getActualQuantity() + _this.getScrapQuantity();

    _this.$form.find('.production-process__item').each(function () {
      var $item = $(this);

      var unitQuantity = _this.getItemFloatValue($item, 'UnitQuantity');
      var newQuantity = unitQuantity * quantity;
      if (unitQuantity > 0) {
        _this.setItemFloatValue($item, 'Quantity', roundToDecimals(newQuantity, 4));
      }

      _this.doRecalculateItemAltUnit($item, newQuantity);
    });

    return _this;
  },

  recalculateItemsQuantity: function recalculateItemsQuantity() {
    var _this = this;

    if (_this.$form.find('.production-process__item').length) {
      if (app.param('is_allowed_auto_recalculate_items_quantity')) {
        _this.doRecalculateItemsQuantity();
      } else {
        app.confirmHtml(app.t('production_process.quantity_recalculation_confirm'), function (ret) {
          if (ret) {
            _this.doRecalculateItemsQuantity();
          }
        });
      }
    }

    return _this;
  },

  isRequiredConfirmQuantity: function isRequiredConfirmQuantity() {
    var _this = this;

    if (!app.param('is_allowed_decrease_operation_quantity')) {
      return false;
    }

    var initQuantity = _this.getInitQuantity();
    var remQuantity = _this.getRemainQuantity();
    var actQuantity = _this.getActualQuantity();
    var scrapQuantity = _this.getScrapQuantity();

    actQuantity = actQuantity + scrapQuantity;

    return actQuantity < Math.min(initQuantity, remQuantity);
  },

  isRequiredChooseReason: function isRequiredChooseReason() {
    var _this = this;

    if (!app.param('is_allowed_multi_scrap')) {
      var remQuantity = _this.getRemainQuantity();
      var actQuantity = _this.getActualQuantity();
      var scrapQuantity = _this.getScrapQuantity();

      var isFinished = _this.getFormFloatValue('IsFinished');

      return (isFinished && actQuantity < remQuantity) || (scrapQuantity > 0);
    }

    return false;
  },

  confirmQuantity: function confirmQuantity() {
    var _this = this;

    var options = {
      content: app.t('production_process.quantity_confirmation'),
      confirmTitle: app.t('production_process.quantity_confirmation_confirm'),
      rejectTitle: app.t('production_process.quantity_confirmation_reject'),
      width: 'lg'
    };

    app.confirmCancelHtml(options, function (ret) {
      if (ret === null) {
        return;
      }

      _this.setFormValue('IsQuantityConfirmed', 1);

      if (!ret) {
        _this.setFormValue('IsFinished', 1);
      }

      _this.submitForm(true, true);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  onChangeScrapQuantity: function onChangeScrapQuantity() {
    var _this = this;

    app.confirmHtml(app.t('production_process.scrap_recalculate_quantity'), function (ret) {
      if (ret) {
        var lastQuantity = _this.getLastQuantity();
        var scrapQuantity = _this.getScrapQuantity();

        _this.setFormFloatValue('OperationQuantity', Math.max(0, lastQuantity - scrapQuantity));
      } else {
        _this.recalculateItemsQuantity();
      }

      _this.validateQuantity(true);
    });

    return _this;
  },

  onChooseScrapReason: function onChooseScrapReason($scrap, reason) {
    var _this = this;

    $scrap.find('.production-process__scrap-reason').removeClass('has-error');

    if (reason) {
      _this.setScrapReason($scrap, reason);

      app.confirmHtml({ content: app.t('production_process.scrap_type_question'), rejectTitle: app.t('production_process.scrap_type_remake'), confirmTitle: app.t('production_process.scrap_type_repair') }, function (ret) {
        if (ret) {
          $scrap.find('.production-process__scrap-type--repaire').prop('checked', true).change();
        } else {
          $scrap.find('.production-process__scrap-type--remake').prop('checked', true).change();
        }
      });
    } else {
      _this.clearScrapReason($scrap);

      $scrap.find('.production-process__scrap-reason').addClass('has-error');
    }

    return _this;
  },

  setScrapReason: function setScrapReason($scrap, reason) {
    var _this = this;

    _this.setItemValue($scrap, 'ReasonId', reason.Id);
    _this.setItemValue($scrap, 'ReasonAbbr', reason.Abbr);
    _this.setItemValue($scrap, 'ReasonDescription', reason.Description);
    $scrap.find('.production-process__scrap-title--description').text(reason.Description);

    return _this;
  },

  clearScrapReason: function clearScrapReason($scrap) {
    var _this = this;

    _this.setItemValue($scrap, 'ReasonId', 0);
    _this.setItemValue($scrap, 'ReasonDescription', '');
    $scrap.find('.production-process__scrap-title--description').text('');

    $scrap.find('.production-process__scrap-reason').removeClass('has-error');

    return _this;
  },

  //----------------------------------------------------------------------------

  changeBarcode: function changeBarcode($input, barcode) {
    var _this = this;

    services.get('barcode-check').checkBarcode(_this.$form, _this.workplaceRID, barcode, {}, function (barcodeType, data) {
      switch (barcodeType) {
        case 'Operation' : services.get('barcode-check').operationBarcode(barcode, data); break;
        default : {
          $input.val('');
          $input.focus();
        }
      }
    });

    return _this;
  },

  changeOperationQuantity: function changeOperationQuantity(name) {
    var _this = this;

    var quantity = parseFloatK2(_this.getFormValue(name));
    if (isNaN(quantity)) {
      app.showMessage(app.t('value.is_not_number'));
      _this.setFormValue(name, 0);
    }

    _this.setFormValue('OperationLastQuantity', quantity);

    _this.validateQuantity(true);
    _this.recalculateItemsQuantity();

    return _this;
  },

  changeOperationQuantityScrap: function changeOperationQuantityScrap(name) {
    var _this = this;

    var quantity = parseFloatK2(_this.getFormValue(name));
    if (isNaN(quantity)) {
      app.showMessage(app.t('value.is_not_number'));
      _this.setFormValue(name, 0);
    }

    _this.onChangeScrapQuantity();

    return _this;
  },

  changeScrapQuantity: function changeScrapQuantity($scrap) {
    var _this = this;

    var quantity = _this.getItemFloatValue($scrap, 'Quantity');
    if (isNaN(quantity)) {
      app.showMessage(app.t('value.is_not_number'));
      _this.setItemFloatValue($scrap, 'quantity', 0);
    }

    _this.onChangeScrapQuantity();

    return _this;
  },

  changeItemQuantity: function changeItemQuantity($item) {
    var _this = this;

    var quantity = _this.getItemFloatValue($item, 'Quantity');
    _this.recalculateItemAltUnit($item, quantity);

    if (app.param('is_allowed_article_replacements') && quantity <= 0) {
      app.showMessageHtml(app.t('production_process.zero_quantity_information'));
    }

    return _this;
  },

  changeScrapReason: function changeScrapReason($scrap) {
    var _this = this;

    var abbr = _this.getItemValue($scrap, 'ReasonAbbr');

    if (abbr) {
      services.get('reason').getReasonByAbbr(abbr, function (reason) {
        _this.onChooseScrapReason($scrap, reason);
      });
    } else {
      _this.clearScrapReason($scrap);
    }

    return _this;
  },

  chooseScrapReason: function chooseScrapReason($scrap) {
    var _this = this;

    services.get('reason').chooseReason(_this.workplaceRID, function (reason) {
      _this.onChooseScrapReason($scrap, reason);
    });

    return _this;
  },

  updateScrapProductionType: function updateScrapProductionType($scrap, productionType) {
    var _this = this;

    _this.setItemFloatValue($scrap, 'ProductionTypeId', productionType.id);
    _this.setItemValue($scrap, 'ProductionTypeDescription', productionType.description);
    $scrap.find('.production-process__scrap-production-type-title--description').text(productionType.description);

    return _this;
  },

  doChooseScrapProductionType: function doChooseScrapProductionType($scrap) {
    var _this = this;

    var parameters = {
      title: app.t('resources.title'),
      content: app.t('resources.choose_help'),
      asHtml: true,
      list: app.param('production_types')
    };

    app.selectValue(parameters, function (val) {
      if (val === null) {
        return _this.doChooseScrapProductionType($scrap);
      }

      var item = getItemById(app.param('production_types'), val);

      _this.updateScrapProductionType($scrap, item);
    });

    return _this;
  },

  chooseScrapProductionType: function chooseScrapProductionType($scrap) {
    var _this = this;

    _this.updateScrapProductionType($scrap, { id: 0, description: '' });

    app.confirmHtml({ content: app.t('production_process.scrap_production_type_question'), rejectTitle: app.t('production_process.scrap_production_type_whole'), confirmTitle: app.t('production_process.scrap_production_type_part') }, function (ret) {
      if (ret) {
        _this.doChooseScrapProductionType($scrap);
      }
    });
  },

  isAllowedAddScrap: function isAllowedAddScrap() {
    var _this = this;

    var $scrap = _this.$form.find('.production-process__scrap:last');

    var reasonId = _this.getItemFloatValue($scrap, 'ReasonId');
    var quantity = _this.getItemFloatValue($scrap, 'Quantity');

    return reasonId !== 0 || quantity !== 0;
  },

  addScrap: function addScrap() {
    var _this = this;

    var $wrapper = _this.$form.find('.production-process__scraps');
    var index = $wrapper.data('index');
    if (isNaN(index)) {
      index = 1;
    }

    var prototypeForm = $wrapper.data('prototype');
    var newForm = prototypeForm.replace(/__name__/g, index);
    var $clone = $(newForm);

    $wrapper.append($clone);
    $wrapper.data('index', index + 1);

    initialize($clone, true);

    return _this;
  },

  removeScrap: function removeScrap($scrap) {
    var _this = this;

    var quantity = _this.getItemFloatValue($scrap, 'Quantity');

    $scrap.remove();

    if (quantity !== 0) {
      _this.onChangeScrapQuantity();
    }
  },

  changeScrapType: function changeScrapType($type) {
    var _this = this;

    var $scrap = $type.closest('.production-process__scrap');
    var $types = $scrap.find('.production-process__scrap-type');

    if (!$types.is(':checked')) {
      $type.prop('checked', true);
    } else {
      $types.not($type).prop('checked', false);
    }

    if (app.param('is_required_choose_production_type')) {
      _this.chooseScrapProductionType($scrap);
    }

    return _this;
  },

  timingChange: function timingChange(time) {
    var _this = this;

    var min = time / (1000 * 60);

    _this.setFormFloatValue('RunTime', roundToDecimals(min, 1));
    _this.getFormField('RunTime').attr('readonly', true);

    return _this;
  },

  timingStart: function timingStart() {
    var _this = this;

    services.get('production-timing').start(_this.getJCOperationRID(), function (timeStart) {
      $('.production-process__timing-start').remove();

      var $stopwatch = $('.stopwatch');
      $stopwatch.data('time_start', timeStart);
      $stopwatch.removeClass('stopwatch--paused');
      $stopwatch.show();
    });

    return _this;
  },

  finishProcess: function finishProcess() {
    var _this = this;

    services.get('production').finishProcess(_this.workplaceRID, _this.getJobCardRID(), _this.getJCOperationRID(), function () {
      _this.doLeavePage();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  doArticleReplacement: function doArticleReplacement($item, data, replaceArticle) {
    var _this = this;

    var $sourceItem = $item;

    var RID = _this.getItemValue($sourceItem, 'RID');
    var tag = guid();
    if (!replaceArticle) {
      var index = _this.$form.find('.production-process__item').length; //cislujeme od nuly
      var prototypeForm = _this.$form.find('.production-process__items').data('prototype');
      var newForm = prototypeForm.replace(/__name__/g, index);
      var $clone = $(newForm);

      $clone.insertAfter($item);

      initialize($clone, true);

      $item = $clone;
    }

    _this.replaceAttrDataValue($item, 'tag', tag);
    $item.find('[data-tag]').each(function () {
      _this.replaceAttrDataValue($(this), 'tag', tag);
    });

    _this.setItemValue($item, 'Tag', tag);
    _this.setItemValue($item, 'ArticleId', data.Id);
    _this.setItemValue($item, 'ArticleAbbr', data.Abbr);
    _this.setItemValue($item, 'ArticleName', data.Name);
    _this.setItemValue($item, 'ArticleCategoryAbbr', data.CategoryAbbr);
    _this.setItemValue($item, 'AltUnit', data.AltUnit);

    if (!replaceArticle) {
      _this.setItemValue($item, 'Quantity', 0);
      _this.setItemValue($item, 'PlanQuantity', 0);
      _this.setItemValue($item, 'UnitQuantity', 0);
    } else {
      var $btn = $item.find('.transfer-note__create');
      $btn.removeClass('btn-danger').addClass('btn-primary');
      $btn.find('.production-process__item-btn-sign').remove();

      if (data.quantityRatio > 0) {
        _this.setItemFloatValue($item, 'Quantity', roundToDecimals(_this.getItemFloatValue($item, 'Quantity') * data.quantityRatio, 4));
      }
    }

    _this.setItemValue($item, 'Dispositions', '');

    _this.setItemValue($item, 'RID', RID);
    _this.replaceAttrDataValue($item, 'RID', RID);

    var $field = null;

    $field = _this.getItemField($item, 'Quantity');
    $field.attr('placeholder', 0);
    $field.closest('.input-group').find('.value-suffix').text(data.AltUnit);

    $field = $item.find('.production-process__item-title');
    _this.replaceAttrDataValue($field, 'article_id', data.Id);

    $field = $item.find('.production-process__item-title--name');
    $field.text(data.Name);

    $field = $item.find('.production-process__item-title--abbr');
    $field.text(data.Abbr);

    $field = $item.find('.production-process__item-title--category');
    $field.text(data.CategoryAbbr);

    $item.find('.production-process__item-btn').each(function () {
      _this.replaceAttrDataValue($(this), 'jcitem_rid', RID);
      _this.replaceAttrDataValue($(this), 'article_id', data.Id);
    });

    $item.find('.production-process__item-dispositions').text('---');
    $item.find('.production-process__item-btn-sign').remove();

    _this.doRecalculateItemAltUnit($item, 0);

    return _this;
  },

  useArticleReplacement: function useArticleReplacement(data) {
    var _this = this;

    var $item = _this.$form.find('.production-process__item[data-tag="' + data.tag + '"]');
    if (!$item.length) {
      return _this;
    }

    var options = {
      content: app.t('production_process.article_replacement'),
      confirmTitle: app.t('production_process.article_replacement_confirm'),
      rejectTitle: app.t('production_process.article_replacement_reject')
    };

    app.confirmCancelHtml(options, function (ret) {
      if (ret === null) {
        return;
      }

      _this.doArticleReplacement($item, data, ret);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  createNewTransferNote: function () {
    var _this = this;

    services.get('article').find(function (id) {
      services.get('transfer-note').create(id, 'new', _this.getJobCardRID(), _this.getJCOperationRID());
    });

    return _this;
  },

  createBulkTransferNote: function () {
    var _this = this;

    var data = [];

    _this.$form.find('.production-process__item').each(function () {
      var $item = $(this);
      var item = {
        ArticleId: _this.getItemValue($item, 'ArticleId'),
        ArticleAbbr: _this.getItemValue($item, 'ArticleAbbr'),
        ArticleAbbr2: _this.getItemValue($item, 'ArticleAbbr2'),
        ArticleName: _this.getItemValue($item, 'ArticleName'),
        ArticleCategoryAbbr: _this.getItemValue($item, 'ArticleCategoryAbbr'),
        AltUnit: _this.getItemValue($item, 'AltUnit'),
        IsAvailable: _this.getItemValue($item, 'IsAvailable'),
        Quantity: 0,
        Tag: $item.data('tag')
      };

      data.push(item);
    });

    services.get('transfer-note').createBulk(data, _this.getJobCardRID(), _this.getJCOperationRID(), _this.getOperationId());

    return _this;
  },

  //----------------------------------------------------------------------------

  toggleJobCardPreparation: function toggleJobCardPreparation(data) {
    var _this = this;

    var $btn = _this.$form.find('.job-card__toggle-preparation');
    var $items = _this.$form.find('.job-card__toggle-item-preparation');
    updateButtonByPreparationStatus($btn, data.PreparationStatus);
    updateButtonByPreparationStatus($items, data.PreparationStatus);

    return _this;
  },

  toggleJobCardItemPreparation: function toggleJobCardItemPreparation(data) {
    var _this = this;

    var $btn = _this.$form.find('.job-card__toggle-preparation');
    var $items = _this.$form.find('.job-card__toggle-item-preparation[data-item_rid="' + data.ItemRID + '"]');
    updateButtonByPreparationStatus($btn, data.JobCardPreparationStatus);
    updateButtonByPreparationStatus($items, data.PreparationStatus);

    return _this;
  },

  //----------------------------------------------------------------------------

  doLeavePage: function doLeavePage() {
    var _this = this;

    _this.isLeaving = true;

    var url = _this.$form.find('.production-process__btn-leave-form').attr('href');
    if (_this.isHolded()) {
      return services.get('production').unholdJCOperation(_this.workplaceRID, _this.getJobCardRID(), _this.getJCOperationRID(), url);
    }

    window.location = url;

    return _this;
  },

  leavePage: function leavePage() {
    var _this = this;

    if (!_this.isLeaving && !_this.isFormSubmited) {
      if (_this.getJobCardRID() && app.param('is_required_confirm_of_leaving')) {
        app.confirmHtml(app.t('production_process.leave_page_confirm'), function (ret) {
          if (ret) {
            _this.doLeavePage();
          }
        });
      } else {
        _this.doLeavePage();
      }
    }
  },

  doSubmitForm: function doSubmitForm() {
    var _this = this;

    services.get('user-additional-login').isUserLogined(function () {
      _this.onSubmitForm(function () {
        _this.$form.submit();
      });
    });

    return _this;
  },

  submitForm: function submitForm(updateAlerts, showMessages) {
    var _this = this;

    if (_this.isFormValid(updateAlerts, showMessages)) {
      var actions = [];

      if (app.param('is_required_confirm_of_processing')) {
        actions.push({ object: _this, fn: 'confirmOfProcessing' });
      }

      if (app.param('is_allowed_add_performance')) {
        actions.push({ object: _this, fn: 'addPerformance' });
      }

      if (app.param('is_required_choose_reason') && _this.isRequiredChooseReason() && !_this.getFormFloatValue('ReasonId')) {
        actions.push({ object: _this, fn: 'chooseReason' });
      }

      if (app.param('is_required_choose_resource') && !_this.getFormFloatValue('ResourceId')) {
        actions.push({ object: _this, fn: 'chooseResource' });
      }

      if (app.param('is_required_scan_location') && _this.getActualQuantity() > 0) {
        actions.push({ object: _this, fn: 'scanLocation' });
      }

      if (app.param('is_required_choose_handling_unit') && _this.getActualQuantity() > 0) {
        actions.push({ object: _this, fn: 'chooseHandlingUnit' });
      }

      if (app.param('is_required_scan_handling_unit') && _this.getActualQuantity() > 0) {
        actions.push({ object: _this, fn: 'scanHandlingUnit' });
      }

      var executor = new FunctionsExecutor();
      executor.execute(actions, function () {
        _this.doSubmitForm();
      });
    } else {
      var isQuantityConfirmed = _this.getFormValue('IsQuantityConfirmed');
      if (!isQuantityConfirmed && _this.isRequiredConfirmQuantity()) {
        _this.confirmQuantity();
      }
    }

    return _this;
  },

  onSubmitForm: function onSubmitForm(callBack) {
    var _this = this;

    _this.setFormValue('InSubmitted', 1);

    callBack();

    return _this;
  },

  isAllowedSubmitForm: function isAllowedSubmitForm() {
    var _this = this;

    if (_this.isLeaving) {
      return false;
    }

    if (_this.isFormValid(true, true)) {
      if (!_this.isFormSubmited) {
        blockElement(_this.$page);
        _this.isFormSubmited = true;
        return true;
      }
    }

    return false;
  },

  isFormValid: function isFormValid(updateAlerts, showMessages) {
    var _this = this;

    var ret = true;
    if (!_this.validateCommon(updateAlerts, showMessages)) {
      ret = false;
    }

    if (!_this.validateQuantity(updateAlerts, showMessages)) {
      ret = false;
    }

    if (!_this.validateScraps(updateAlerts, showMessages)) {
      ret = false;
    }

    if (!_this.validateItems(updateAlerts, showMessages)) {
      ret = false;
    }

    return ret;
  },

  viewAlerts: function viewAlerts() {
    var _this = this;

    if (_this.getJobCardRID()) {
      if (app.param('is_allowed_start_processing_alert')) {
        app.showMessageHtml(app.t('production_process.start_alert'));
      }
    }

    return _this;
  },

  onOpen: function onOpen() {
    var _this = this;

    if (isEmpty(_this.$inputOperationBarcode.val()) && isEmpty(_this.getJCOperationRID())) {
      _this.$inputOperationBarcode.focus();
    } else {
      _this.$inputOtherBarcode.focus();
    }

    if (!_this.getFormValue('InSubmitted')) {
      _this.doRecalculateItemsQuantity();
      _this.viewAlerts();
    } else {
      _this.recalculateItemAltUnit();
    }

    _this.loadSpecialAction();

    return _this;
  },

  loadSpecialAction: function loadSpecialAction() {
    var _this = this;

    if (app.param('is_allowed_special_detail_action')) {
      var $wrapper = _this.$body.find('.production-process__special-action-content');

      var data = {
        JobCardRID: _this.getJobCardRID(),
      };

      app.getFormation(app.param('special_detail_action'), data, function (res) {
        if (res.msg === 'SUCCESS') {
          $wrapper.html(res.data.Content);
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    }

    return _this;
  },

  changeArticleWeight: function changeArticleWeight(data) {
    var _this = this;

    if (data.weight < 0) {
      return _this;
    }

    var $btn = null;
    var $btnSecond = null;
    switch (data.weightType) {
      case weightNetto : {
        _this.setFormFloatValue('ArticleWeightNetto', data.weight);
        $btn = _this.$body.find('.article__change-weight--netto');
        $btnSecond = _this.$body.find('.article__change-weight--brutto');
      }

      break;

      case weightBrutto : {
        _this.setFormFloatValue('ArticleWeightBrutto', data.weight);
        $btn = _this.$body.find('.article__change-weight--brutto');
        $btnSecond = _this.$body.find('.article__change-weight--netto');
      }

      break;
    }

    if (!$btn) {
      return;
    }

    if (data.weight > 0) {
      $btn.removeClass('btn-danger');
      $btn.addClass('btn-info');
    } else {
      $btn.removeClass('btn-info');
      $btn.addClass('btn-danger');
    }

    if ($btnSecond.hasClass('btn-danger')) {
      $btnSecond.trigger('click');
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  confirmOfProcessing: function confirmOfProcessing(callback) {
    var _this = this;

    app.confirmHtml(app.t('production_process.submit_form_confirm'), function (ret) {
      if (ret) {
        callback();
      }
    });

    return _this;
  },

  confirmProductSerialNumberParamters: function confirmProductSerialNumberParamters(callback) {
    var _this = this;

    app.confirmHtml(app.t('production_process.confirm_product_serial_number_parameters'), function (ret) {
      if (ret) {
        callback();
      }
    });

    return _this;
  },

  chooseReason: function chooseReason(callback) {
    var _this = this;

    services.get('reason').chooseReason(_this.workplaceRID, function (reason) {
      if (reason === null) {
        return _this;
      }

      _this.setFormValue('ReasonId', reason.Id);

      callback();
    });

    return _this;
  },

  chooseResource: function chooseResource(callback) {
    var _this = this;

    var parameters = {
      title: app.t('resources.title'),
      content: app.t('resources.choose_help'),
      asHtml: true,
      list: app.param('resources')
    };

    app.selectValue(parameters, function (val) {
      if (val === null) {
        return _this.chooseResource(callback);
      }

      _this.setFormValue('ResourceId', val);

      callback();
    });

    return _this;
  },

  scanLocation: function scanLocation(callback) {
    var _this = this;

    var content = '';
    content += '<div class="text-center">' + app.t('barcode.scan_location') + '</div>';

    services.get('barcode').scanAndFindBarcode(btLocation, { content: content }, _this.getFormFloatValue('WarehouseId'), function (res, data) {
      if (res === resClose) {
        return;
      } else if (res === resError) {
        _this.scanLocation(callback);
      } else {
        _this.setFormValue('LocationId', data.Id);

        callback();
      }
    });

    return _this;
  },

  chooseHandlingUnit: function chooseHandlingUnit(callback) {
    var _this = this;

    var parameters = {
      title: app.t('handling_unit.title'),
      content: app.t('resources.choose_help'),
      asHtml: true,
      list: app.param('handling_units')
    };

    app.selectValue(parameters, function (val) {
      if (val === null) {
        if (!app.param('is_handling_unit_mandatory')) {
          return callback();
        }

        return _this.chooseHandlingUnit(callback);
      }

      _this.setFormValue('HandlingUnitRID', val);

      callback();
    });

    return _this;
  },

  scanHandlingUnit: function scanHandlingUnit(callback) {
    var _this = this;

    var content = '';

    //content += '<div class="text-right"><a href="#" class="btn btn-primary btn-sm offset-bottom-20 handling-unit__generate">' + app.t('handling_unit.generate') + '</a></div>';

    content += '<div class="text-center">' + app.t('barcode.scan_handling_unit') + '</div>';

    services.get('barcode').scanAndFindBarcode(btHandlingUnit, { content: content }, 0, function (res, data) {
      if (res === resClose) {
        if (!app.param('is_handling_unit_mandatory')) {
          return callback();
        }

        return;
      } else if (res === resError) {
        _this.scanHandlingUnit(callback);
      } else {
        _this.setFormValue('HandlingUnitRID', data.RID);

        callback();
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$body = $('body');
    _this.$container = $('#' + _this.containerId);
    _this.$form = _this.$container.find('form');
    _this.$inputOperationBarcode = _this.$form.find('.production-process__operation-barcode');
    _this.$inputOtherBarcode = _this.$form.find('.production-process__other-barcode');
    _this.$page = $('html');

    _this.registerCallbacks();
    _this.onOpen();

    return _this;
  }
});
